module.exports = __webpack_public_path__ + "img/didier.bcd2b3f0.png";